import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Carousel from "react-bootstrap/Carousel";
import Host from "../../Components/Host";
import HomeData from "../../Components/HomeData";
import { useMediaQuery } from "react-responsive";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "./heroCarousel.scss";

function HomeCarousel() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: "(min-width: 0px) and (max-width: 768px)" });
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = isMobile ? HomeData?.carousel : Host?.bannesImages;

  if (!slides?.length) return null;

  const goTo = (index) => {
    setActiveIndex(((index % slides.length) + slides.length) % slides.length);
  };

  return (
    <div className="hp-hero" role="region" aria-roledescription="carousel" aria-label={t("promotions", "Promotions")}>
      <div className="hp-hero__frame">
        <Carousel
          activeIndex={activeIndex}
          onSelect={goTo}
          controls={false}
          indicators={false}
          fade
          pause="hover"
          touch
        >
          {slides.map((item, i) => (
            <Carousel.Item key={i} interval={3500}>
              <Link className="hp-hero__slide" to={item?.link || "#"}>
                <img
                  className="hp-hero__img"
                  loading={i === 0 ? "eager" : "lazy"}
                  fetchpriority={i === 0 ? "high" : "auto"}
                  src={item?.image}
                  alt={item?.alt || ""}
                />
              </Link>
            </Carousel.Item>
          ))}
        </Carousel>

        {slides.length > 1 && (
          <>
            {/* <button
              type="button"
              className="hp-hero__arrow hp-hero__arrow--prev"
              onClick={() => goTo(activeIndex - 1)}
              aria-label={t("previous", "Previous")}
            >
              <ChevronLeftIcon />
            </button>
            <button
              type="button"
              className="hp-hero__arrow hp-hero__arrow--next"
              onClick={() => goTo(activeIndex + 1)}
              aria-label={t("next", "Next")}
            >
              <ChevronRightIcon />
            </button> */}

            <div className="hp-hero__dots">
              {slides.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  className={`hp-hero__dot${i === activeIndex ? " is-active" : ""}`}
                  onClick={() => goTo(i)}
                  aria-label={t("go_to_slide", "Go to slide {{n}}", { n: i + 1 })}
                  aria-current={i === activeIndex}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default HomeCarousel;
